import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataToDownload: {},
};

const energyPerformanceSliceNew = createSlice({
  initialState,
  name: "energyPerformanceNew",
  reducers: {
    setDataToDownload: (state, { payload }) => {
      state.dataToDownload = { ...state.dataToDownload, [payload.id]: payload.data };
    },
  },
});

export const { setDataToDownload } = energyPerformanceSliceNew.actions;
export default energyPerformanceSliceNew.reducer;
